import React from 'react';
import { connect } from 'react-redux';
import CategoryLink from '../Components/CategoryLink';

const CategoryLinkContainer = props => (
    <CategoryLink {...props} />
)

const mapStateToProps = state => {
    return {
        links: state.navigation.contentLinks,
    }
}

const mapDispatchToProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryLinkContainer);
